module.exports = __webpack_public_path__ + "img/homeAds.a78e4ec3.png";